module.exports = __webpack_public_path__ + "media/images/pc/resort_plans/slider_button_prev-13274abb9f343ece4208f515f52a43bd.svg";